<template>
  <div class="loading-container">
    <div class="video-container">
      <video :src="loadingVideo" autoplay loop  muted playsinline webkit-playsinline width="212" height="182"></video>
    </div>
    <div class="spinner-container">
      <Spinner :color=color />
    </div>
  </div>
</template>

<script>
import Spinner from '../spinner/Spinner.vue';
import loadingVideo from "@/assets/animations/re-digitando.mp4";
export default {
  components: { Spinner },
  name: "ReLoading",
  props: {
      color: {
        type: String,
        default: "#0984e3"
      }
  },
  data: () => ({
    loadingVideo
  })
};
</script>

<style scoped lang="scss">

.loading-container {
  position: relative;

  .video-container {
    border-radius: 1000px;
    width: 144px;
    height: 144px;
    overflow: hidden;
    position: relative;

    video {
      width: 144px;
      height: 144px;
    }
  }
  .spinner-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 160px;
    height: 160px;
  }
}
</style>
